module.exports = __webpack_public_path__ + "img/xlf-icon.1db3eb21.svg";